
import Vue from 'vue'
import Component from 'vue-class-component'
import colors from 'vuetify/lib/util/colors'

const NameAvatarProps = Vue.extend({
  props: {
    name: String,
  },
})

@Component({
  inheritAttrs: false,
})
export default class NameAvatar extends NameAvatarProps {
  get userColor(): string {
    const _colors = [
      colors.red,
      colors.pink,
      colors.purple,
      colors.deepPurple,
      colors.indigo,
      colors.blue,
      colors.lightBlue,
      colors.cyan,
      colors.teal,
      colors.green,
      colors.lightGreen,
      colors.lime,
      colors.amber,
      colors.orange,
      colors.deepOrange,
      colors.brown,
      colors.blueGrey,
    ]
    return _colors[Math.abs(this.hashCode % _colors.length)].base
  }

  get hashCode(): number {
    let hash = 0
    for (let i = 0; i < this.name.length; i++) {
      const character = this.name.charCodeAt(i)
      hash = (hash << 5) - hash + character
      hash = hash & hash
    }
    return hash
  }
}
